const faqItems = [
  {
    q: '蓝莓影院真的完全免费吗？',
    a: '是的，蓝莓影院所有影视内容均为免费在线观看，不收取任何费用。无需注册会员、无需付费订阅，打开网页即可即点即看。我们通过广告合作维持平台运营，绝不会向观众收费。',
  },
  {
    q: '视频画质怎么样？会不会很模糊？',
    a: '蓝莓影院所有片源均为1080P及以上高清品质，部分热门影片支持4K超清画质。我们对每部上架影片进行画质审核，拒绝渣画质资源。只要您的网络带宽足够，就能享受清晰流畅的观影体验。',
  },
  {
    q: '播放时会不会卡顿缓冲？',
    a: '蓝莓影院采用多线CDN加速与智能预加载技术，在正常网络环境下播放流畅不卡顿。如果遇到缓冲，建议检查网络状态或降低清晰度，大多数情况下都能实现秒开零等待。',
  },
  {
    q: '每天什么时候更新新内容？',
    a: '我们的编辑团队每日追踪各大平台最新动态，热播剧集通常在当天晚间更新，新上线电影随时补充。每日更新量约200+部，您可以通过「最新动态」模块查看每日更新详情。',
  },
  {
    q: '支持手机和平板观看吗？',
    a: '完全支持。蓝莓影院针对移动端做了全面适配优化，在手机和平板上同样享受高清流畅的观影体验。页面自适应屏幕尺寸，操作便捷，随时随地想看就看。',
  },
  {
    q: '如果喜欢的影片搜不到怎么办？',
    a: '您可以通过「联系我们」模块向我们提交影片名称，我们的内容团队会尽快评估并优先上架。同时也欢迎您对平台提出任何改进建议，帮助我们做得更好。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">关于蓝莓影院，您可能想了解的事情都在这里</p>
        </div>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.q}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2">{item.q}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}